import { useAppContext } from "AppContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DoorstopItem } from "shared/components";

export const useAppDoorstop = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const {
    dbUser,
    dbUserError,
    dbUserLoading,
    organizations,
    organizationsError,
    organizationsLoading,
    operators,
    operatorsError,
    operatorsLoading,
    updateUserAccessStatus,
  } = useAppContext();

  /**
   * Conditionally render the correct screen based off the user's onboarding
   * status and access
   */
  useEffect(() => {
    if (!dbUser) {
      return;
    }
    // If the user has NOT seen the welcome carousel, navigate to it
    if (!dbUser.onboardingMetadata?.isPostOnboarding) {
      navigate("/app/welcome", { replace: true });
    } else if (
      !organizationsError &&
      !organizationsLoading &&
      !operatorsError &&
      !operatorsLoading &&
      organizations.length + operators.length === 1
    ) {
      /**
       * If the user only has access to a single entity, we can directly
       * navigate to that entity or the operators home page
       */
      const path =
        organizations.length === 1
          ? `/app/organization/${organizations[0]._id}`
          : "/app/operator";
      navigate(path, { replace: true });
    } else if (
      !organizationsError &&
      !organizationsLoading &&
      !operatorsError &&
      !operatorsLoading &&
      organizations.length < 1
    ) {
      /**
       * If the user only has operators in their access, we can directly
       * navigate to the operators home page
       */
      navigate("/app/operator");
    }
  }, [
    dbUser,
    organizations,
    organizationsError,
    organizationsLoading,
    operators,
    operatorsError,
    operatorsLoading,
    navigate,
  ]);

  /**
   * When a user logs into a given organization OR operator,
   * we need to set their access status to Accepted
   * @param path
   */
  const handleNavigate = async (item: DoorstopItem) => {
    await updateUserAccessStatus(item.type, item._entityId);
    navigate(item.path);
  };

  return {
    loading: dbUserLoading || organizationsLoading || operatorsLoading,
    error: dbUserError || organizationsError || operatorsError,
    onItemClick: handleNavigate,
    operators,
    organizations,
    isModalOpen,
    setIsModalOpen,
  };
};
